import {u8_to_utf8} from 'u8-utils'

const json_codec = @{}
  name: 'JSON'
  encode: (pkt) => JSON.stringify(pkt)
  decode: data => JSON.parse @
    'string' === typeof data ? data
      : u8_to_utf8(data)

export function json_codec_plugin() ::
  return hub => ::
    hub._root_.as_stream_codec(json_codec)

